import React from 'react';
import { useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { colors } from '../../theme';
import { CMSContent } from '../../containers/cmscontent/CMSContent';

const pardotFormUrl = process.env.CONTACT_PARDOT_FORM_URL;

const useStyles = makeStyles()((theme: Theme) =>
    ({
        contactUs: {
            flexGrow: 1,
            width: '100%',
            flexDirection: 'column',
            display: 'flex',
            margin: 0,
            position: 'relative',
            backgroundColor: colors.blue,
        },

        bar: {
            flexDirection: 'row',
            display: 'flex',
            justifyContent: 'center',
            padding: theme.spacing(10),
        },

        splitBox: {
            minHeight: 900,
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-start',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            margin: theme.spacing(2)
        },

        pardotForm:{
            height: "100%",
            width: "100%",
            backgroundColor: colors.white
        }
    }));

const LandingContactUsPage: React.FC = () => {
    const { classes } = useStyles();

    useEffect(() => {}, []);

    return (
    <div className={classes.contactUs}>
        <div className={classes.bar}>
            <div className={classes.splitBox}>
                <iframe className={classes.pardotForm} src={pardotFormUrl} title="Contact Form" frameBorder="0"></iframe>
            </div>
            <div className={classes.splitBox}>
                <div id="contactUsContent">
                    <CMSContent type="contentitem" name="contact-general"/>
                </div>
            </div>
        </div>
    </div>

    );
};

export default LandingContactUsPage;
